import { FC, Fragment, useCallback } from 'react';

import { activeStatuses, CampaignArchiveReason, CampaignStatus, warnStatuses } from 'utils/constants/dashboard';
import { NotificationName } from 'utils/constants/notification';

import dashboardCampaignSwitcherButtonClick from '@hh.ru/analytics-js-events/build/clickme/employer/common/dashboard_campaign_switcher_button_click';

import Switch from 'components/Switch';

import { fetchCampaignsCount } from 'components/CampaignCard/CampaignInfo/Actions/fetchCampaignsCount';
import Status from 'components/CampaignCard/CampaignInfo/Actions/Status';
import { updateCampaignStatus } from 'components/CampaignCard/CampaignInfo/Actions/updateCampaignStatus';

import { selectUpdateCampaignStatusLoading, setUpdateCampaignStatusLoading } from 'store/autoReducers';
import { Banner, CampaignTabStatus, FrontendStatusType } from 'store/models/dashboard';
import { addNotification } from 'store/models/notification';
import { useDispatch, useSelector } from 'store/utils';

interface ActionsProps {
    campaignId: number;
    frontendStatus: FrontendStatusType;
    archiveReason: CampaignArchiveReason | null;
    userBalance: number;
    realBalance: number;
    banners: Banner[];
    isAuction: boolean;
    vacancyId: number | null;
    startAt: string | null;
    endAt: string | null;
}

const Actions: FC<ActionsProps> = ({
    campaignId,
    frontendStatus,
    archiveReason,
    userBalance,
    realBalance,
    banners,
    isAuction,
    vacancyId,
    startAt,
    endAt,
}) => {
    const currentStatus: CampaignTabStatus = useSelector((state) => state.campaignTabsStatus);
    const dispatch = useDispatch();
    const isLoading = useSelector(selectUpdateCampaignStatusLoading);

    const onChange = useCallback(() => {
        dispatch(setUpdateCampaignStatusLoading(true));
        dashboardCampaignSwitcherButtonClick({ activeStatus: frontendStatus, campaignId });
        return dispatch(updateCampaignStatus(campaignId, currentStatus))
            .then(() => {
                void dispatch(fetchCampaignsCount());
            })
            .catch(() => {
                dispatch(addNotification(NotificationName.SomethingWentWrong));
            })
            .finally(() => {
                dispatch(setUpdateCampaignStatusLoading(false));
            });
    }, [dispatch, frontendStatus, campaignId, currentStatus]);

    return (
        <Fragment>
            <Switch
                value={activeStatuses.includes(frontendStatus)}
                disabled={isLoading || frontendStatus === CampaignStatus.Archived}
                onChange={onChange}
                warning={warnStatuses.includes(frontendStatus)}
                qa="campaign-block__toggler"
            />
            <Status
                campaignId={campaignId}
                frontendStatus={frontendStatus}
                userBalance={userBalance}
                realBalance={realBalance}
                archiveReason={archiveReason}
                banners={banners}
                isAuction={isAuction}
                vacancyId={vacancyId}
                startAt={startAt}
                endAt={endAt}
            />
            <input type="hidden" value={campaignId} data-qa="campaign-block__id" />
        </Fragment>
    );
};

export default Actions;
